export const { log, warn, error, info, debug } = console;
//# sourceMappingURL=error-logging.js.map